import React, { useState, useEffect, useCallback } from "react";
import axios from '../../api/apiClient';

import { 
    CreateTable, 
    SearchBar,
    Button
} from './../../common/APICommon';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';

function OnBoardingPersonnel({user, isHideSideMenu}) {
    var headers = [
        "Employee Id",
        "Last Name",
        "First Name",
        "Middle Name",
        "Is Active?",
        "Actions"
    ]
    var accessors = [
        "employeeId",
        "lastName",
        "firstName",
        "middleName",
        "isActive",
        "actions"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [data, setData] = useState([]);
    const [selectedData, setSelectedData] = useState(null);

    const [employeeId, setEmployeeId] = useState("")
    const [lastName, setLastName] = useState("")
    const [firstName, setFirstName] = useState("")
    const [middleName, setMiddleName] = useState("")
    const [isActive, setIsActive] = useState(false)

    const resetLocalVariables = () => {
        setEmployeeId("");
        setLastName("");
        setFirstName("");
        setMiddleName("");
        setIsActive(false);
        setSelectedData(null);
    }
    
    // Retrieve
    const [filterData, setFilterData] = useState([]);
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/OnBoardingPersonnel";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        
    }, [fetchData]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = filterData.filter((f) =>
                f?.fullName.toLowerCase().includes(lowercaseValue)||
                f?.employeeId?.toString()?.toLowerCase()?.startsWith(lowercaseValue)
                );

        setData(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            employeeId: employeeId,
            lastName: lastName,
            firstName: firstName,
            middleName: middleName,
            isActive: isActive
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            employeeId: employeeId,
            lastName: lastName,
            firstName: firstName,
            middleName: middleName,
            isActive: isActive
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${selectedData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowEditForm(false);
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };

    const editHandleClick = (data) => {
        setSelectedData(data);
        setEmployeeId(data.employeeId);
        setLastName(data.lastName);
        setFirstName(data.firstName);
        setMiddleName(data.middleName);
        setIsActive(data.isActive);
        openEditHandleClick();
    };
    const openAddHandleClick = () => {
        setShowAddForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
        resetLocalVariables();
    };
    const openEditHandleClick = () => {
        setShowEditForm(true);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
        resetLocalVariables();
    };

    const actions = [
        { 
            name: "Edit", 
            tooltip: "edit",
            icon: <EditIcon fontSize="small" />,
            className: "bg-green-500 hover:bg-green-600 flex items-center",
            function: editHandleClick,
            visible: true,
        },
    ];
    
    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="MainteInfo shadow-xl">
                        <div className="mainteHeader">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Personnel >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"On Boarding Personnel"}</span>
                            </div>
                            <h3>On Boarding Personnel</h3>
                        </div>
                        <div className='p-4 space-y-4'>
                            <SearchBar handleFilter={handleFilter}/>

                            <Button icon={<AddIcon/>} 
                                name={"Add"}
                                className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
                                onClick={openAddHandleClick}
                            />
                            <CreateTable
                                tableName={"OnBoardingPersonnel"}
                                headers={headers}
                                accessors={accessors}
                                data={data}
                                actions={actions}
                
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                itemsPerPage={10}
                                totalItems={data?.length}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <AddEditForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    employeeId={employeeId} setEmployeeId={setEmployeeId}
                    lastName={lastName} setLastName={setLastName}
                    firstName={firstName} setFirstName={setFirstName}
                    middleName={middleName} setMiddleName={setMiddleName}
                    isActive={isActive} setIsActive={setIsActive}
                    handleSubmit={handleSubmit}
                    modalName={"Add Personnel"}
            >
            </AddEditForm>
            <AddEditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    employeeId={employeeId} setEmployeeId={setEmployeeId}
                    lastName={lastName} setLastName={setLastName}
                    firstName={firstName} setFirstName={setFirstName}
                    middleName={middleName} setMiddleName={setMiddleName}
                    isActive={isActive} setIsActive={setIsActive}
                    handleSubmit={handleUpdate}
                    modalName={"Update Personnel"}
            >
            </AddEditForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function AddEditForm({
    isOpen, 
    modalName,
    onClose,
    employeeId, setEmployeeId,
    lastName, setLastName,
    firstName,setFirstName,
    middleName, setMiddleName,
    isActive, setIsActive,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employeeId || !lastName || !firstName){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setEmployeeId("");
        setLastName("");
        setFirstName("");
        setMiddleName("");
        setIsActive(false);
        setErrorState(false);
    };

    const handleIsActiveChange = (event) => {
        setIsActive(event.target.checked);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{modalName}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee Id</div>
                            <div className="info-item-input">
                                <input
                                placeholder="Employee Id"
                                value={employeeId}
                                onChange={(e) => setEmployeeId(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !employeeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Last Name</div>
                            <div className="info-item-input">
                                <input
                                placeholder="Last Name"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !lastName && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">First Name</div>
                            <div className="info-item-input">
                                <input
                                placeholder="First Name"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !firstName && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Middle Name</div>
                            <div className="info-item-input">
                                <input
                                placeholder="Middle Name"
                                value={middleName}
                                onChange={(e) => setMiddleName(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !middleName && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(e)=>handleIsActiveChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export default OnBoardingPersonnel
